import React, { Component } from 'react'

import Modal from './Modal'

import Backend from '../../../utils/Backend'
export default class DeleteCategoryModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
      category: props.category,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  _deleteCategory() {
    let { category } = this.state
    Backend.deleteCategory(category)
      .then((category) => {
        this.props.onCategoryDeleted()
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  render() {
    let { category } = this.state
    if (!category) {
      return null
    }
    return (
      <Modal
        className="delete-category p-btm"
        show={this.state.show}
        onHide={() => {
          this.props.onHide()
        }}
      >
        <div>
          <div className="title">
            Delete <strong>{category.name}</strong> Category
          </div>
          <div>
            <span>Are you sure you would like to delete this category?</span>
          </div>
          <div className="mt-3">
            <button
              type="button"
              className="btn btn-warning me-2"
              onClick={() => this._deleteCategory()}
            >
              Delete
            </button>
            <button
              type="button"
              className="btn btn-light"
              onClick={() => this.props.onHide()}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}
